module.exports = __webpack_public_path__ + "img/new-home.bec6e76b.png";